import React from "react";
import { Alert } from "@xplatform/design-system";
import { Stack } from "@mantine/core";
import { useTranslation } from "react-i18next";
import type { SourceState } from "@models/adminMonitoring";

/** One notice per data source that did not answer; metering data stays visible. */
const SourceAlerts: React.FC<{ sources: SourceState[] | undefined }> = ({ sources }) => {
  const { t } = useTranslation();
  const degraded = (sources ?? []).filter((s) => s.status === "unavailable" || s.status === "unconfigured");
  if (!degraded.length) return null;
  return (
    <Stack gap="xs">
      {degraded.map((source) => (
        <Alert key={source.source} color={source.status === "unavailable" ? "yellow" : "gray"}
               title={t(`admin.insights.sources.${source.status}`, { source: source.source })}>
          {t("admin.insights.sources.partial")}
        </Alert>
      ))}
    </Stack>
  );
};

export default SourceAlerts;
